import { styled } from '@linaria/react';
import { FileLink } from '../../../../pages/admin/AdminPage.styles';

export const ProcedureCard = styled.div`
    padding: 1rem;
    background: #f8f9fa;
    border-radius: 4px;
    border-left: 4px solid #6c757d;
    margin: 1rem 0;

    &:first-of-type {
        margin-top: 1.5rem;
    }

    h3 {
        font-weight: 700;
        color: #333;
        margin: 0 0 0.75rem 0;
        font-size: 1.1rem;
    }
`;

export const ProcedureMeta = styled.div`
    display: flex;
    gap: 1rem;
    margin-bottom: 0.75rem;
    color: #6c757d;
    font-size: 0.875rem;
`;

export const ProcedureDescription = styled.div`
    color: #495057;
    line-height: 1.5;
    margin-bottom: 0.75rem;

    pre {
        white-space: pre-wrap;
        word-wrap: break-word;
        font-family: inherit;
        margin: 0;
    }

    p {
        margin: 0 0 0.5rem 0;
    }
`;

export const ProcedureComments = styled.div`
    padding: 0.75rem;
    background: #fff3cd;
    border-left: 3px solid #ffc107;
    border-radius: 4px;
    font-size: 0.875rem;
    color: #856404;

    label {
        display: block;
        font-weight: 600;
        margin-bottom: 0.5rem;
        color: #856404;
    }

    pre {
        white-space: pre-wrap;
        word-wrap: break-word;
        font-family: inherit;
        margin: 0;
        color: #856404;
    }
`;

export const ProcedureTitle = styled.h4`
    font-weight: 700;
    color: #333;
    margin: 0 0 0.75rem 0;
    font-size: 1.1rem;
`;

export const ProcedureFileLink = styled(FileLink)`
    margin-bottom: 0.75rem;
    font-size: 0.875rem;
`;

export const CommentsSection = styled.div`
    margin-top: 1.5rem;
    padding-top: 1rem;
    border-top: 1px solid #dee2e6;
`;

export const CommentsLabel = styled.label`
    display: block;
    font-weight: 600;
    color: #495057;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
`;

export const CommentsText = styled.pre`
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: inherit;
    font-size: 0.875rem;
    color: #333;
    margin: 0;
    line-height: 1.6;
    background: #f8f9fa;
    padding: 0.75rem;
    border-radius: 4px;
    border: 1px solid #dee2e6;
`;

export const FeedbackSection = styled.div`
    margin-top: 2rem;
    padding: 1.5rem;
    background: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #dee2e6;
`;

export const FeedbackTitle = styled.h4`
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
    margin: 0 0 0.5rem 0;
`;

export const FeedbackDescription = styled.p`
    color: #6c757d;
    margin: 0 0 1rem 0;
    font-size: 0.875rem;
`;

export const FeedbackTextarea = styled.textarea`
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-family: inherit;
    font-size: 0.875rem;
    resize: vertical;
    margin-bottom: 1rem;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
`;

export const FeedbackButton = styled.button`
    background: #007bff;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    font-size: 0.875rem;
    transition: all 0.2s;

    &:hover:not(:disabled) {
        background: #0056b3;
    }

    &:disabled {
        background: #6c757d;
        cursor: not-allowed;
        opacity: 0.6;
    }
`;

export const NoProceduresMessage = styled.p`
    color: #6c757d;
    font-style: italic;
    margin: 1rem 0;
`;

export const EditSelect = styled.select`
    padding: 0.375rem 0.5rem;
    font-size: 0.875rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: linear-gradient(to bottom, #f8f9fa, #e9ecef);
    cursor: pointer;
    min-width: 150px;
    
    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    }
`;

export const EditTextarea = styled.textarea`
    width: 100%;
    min-height: 80px;
    padding: 0.5rem;
    font-size: 0.875rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: #ffffff;
    resize: vertical;
    font-family: inherit;
    
    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
    }
`;

export const RemoveProcedureButton = styled.button`
    padding: 0.25rem 0.5rem;
    background: #dc3545;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.875rem;
    transition: background 0.2s;
    
    &:hover {
        background: #c82333;
    }
`;

export const ProcedureCardHeader = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
`;

export const AddProcedureWrapper = styled.div`
    margin: 1rem 0;
    padding: 1rem;
    background: #f8f9fa;
    border-radius: 4px;
    border: 1px dashed #dee2e6;
    
    label {
        display: block;
        font-weight: 600;
        color: #495057;
        margin-bottom: 0.5rem;
        font-size: 0.875rem;
    }
`;

export const CommentsEditSection = styled.div`
    margin-top: 1.5rem;
    padding: 1rem;
    background: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 4px;
`;


